import { render } from "./DashboardSection.vue?vue&type=template&id=68a14092&scoped=true"
import script from "./DashboardSection.vue?vue&type=script&lang=js"
export * from "./DashboardSection.vue?vue&type=script&lang=js"

import "./DashboardSection.vue?vue&type=style&index=0&id=68a14092&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a14092"]])

export default __exports__